// Query-key factory for the New Deal wizard's Business lookup (stale-after-save
// convention: queryKey literals live in a *Keys file, and the inline business
// create invalidates the businesses prefix so a freshly created record appears
// in any mounted business list). Borrower/Seller party keys are owned by
// partiesKeys (via useCreateParty / PartyPicker); broker reads use brokerKeys.

export const newDealBusinessKeys = {
  all: ["counterparties", "businesses"] as const,
  picker: (term: string) => ["counterparties", "businesses", "picker", term] as const,
};
